import { api } from '../../../../../../utils/api/api';

export const downloadDevis = async (consultationId: number, consultationMatchId: number) => {
  const response = await api.get(
    `consultations/download/devis?consultationId=${consultationId}&consultationMatchId=${consultationMatchId}`,
    {},
    {
      responseType: 'blob',
      method: 'GET',
    }
  );

  const { ok, data } = response;

  if (!ok) {
    const error = response.data;
    console.log('An error occurred.', error);
    throw error;
  }

  // @ts-ignore
  const href = URL.createObjectURL(data);

  const link = document.createElement('a');
  link.href = href;
  link.setAttribute('download', 'Devis.zip');
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};

export const downloadZipDevis = async (consultationId: number) => {
  const response = await api.get(
    `consultations/download/zip_devis?consultationId=${consultationId}`,
    {},
    {
      responseType: 'blob',
      method: 'GET',
    }
  );

  const { ok, data } = response;

  if (!ok) {
    const error = response.data;
    console.log('An error occurred.', error);
    throw error;
  }

  // @ts-ignore
  const href = URL.createObjectURL(data);

  const link = document.createElement('a');
  link.href = href;
  link.setAttribute('download', `Devis de la consultation #${consultationId}.zip`);
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};
